import { Controller } from "@hotwired/stimulus"

// Le modifiche non salvate restano quando la pagina (o un suo contenitore) è riletta con morph: React teneva i campi
// nello stato e load() non li toccava. Un'unità (un form o un gruppo di campi con data-conserva-modifiche-unita e un
// id stabile) diventa «modificata» al primo input/change o quando le sue righe cambiano (righe:aggiunta, righe:tolta);
// finché lo è, turbo:before-morph-element la salta (resta com'è, righe aggiunte o tolte comprese). L'invio del suo form
// la rende di nuovo «pulita», così la risposta la riscrive con i dati salvati (setLink(data.link)); un invio non
// riuscito la segna di nuovo come modificata. Un form può contenere più unità (es. le celle del passo 3 della scheda di
// verifica): il suo invio le rende tutte pulite e un invio non riuscito rimette modificate quelle che lo erano.
//   <div data-controller="conserva-modifiche" data-action="input->conserva-modifiche#modifica change->conserva-modifiche#modifica
//     righe:aggiunta->conserva-modifiche#modifica righe:tolta->conserva-modifiche#modifica
//     turbo:submit-start->conserva-modifiche#inviata turbo:submit-end->conserva-modifiche#inviato
//     turbo:before-morph-element->conserva-modifiche#trattieni">
//     <form id="…" data-conserva-modifiche-unita>…</form>
export default class extends Controller {
  static UNITA = "[data-conserva-modifiche-unita]"
  static MODIFICATA = "conservaModificheModificata"

  modifica(event) {
    const unita = event.target.closest?.(this.constructor.UNITA)
    if (unita && this.element.contains(unita)) unita.dataset[this.constructor.MODIFICATA] = ""
  }

  inviata(event) {
    const unita = this.unitaDelForm(event.target)
    const modificate = unita.filter((u) => u.dataset[this.constructor.MODIFICATA] !== undefined)
    this.inviate = new Map([...(this.inviate || []), [event.target, modificate]])
    unita.forEach((u) => { delete u.dataset[this.constructor.MODIFICATA] })
  }

  inviato(event) {
    const modificate = this.inviate?.get(event.target)
    this.inviate?.delete(event.target)
    if (event.detail?.success) return
    const unita = event.target.closest?.(this.constructor.UNITA)
    if (unita) unita.dataset[this.constructor.MODIFICATA] = ""
    ;(modificate || []).forEach((u) => { if (u !== unita) u.dataset[this.constructor.MODIFICATA] = "" })
  }

  // l'unità che contiene il form e quelle dentro il form
  unitaDelForm(form) {
    const dentro = form.querySelectorAll ? [...form.querySelectorAll(this.constructor.UNITA)] : []
    const fuori = form.closest?.(this.constructor.UNITA)
    return fuori ? [fuori, ...dentro] : dentro
  }

  trattieni(event) {
    const el = event.target
    if (el instanceof Element && el.matches(this.constructor.UNITA) && el.dataset[this.constructor.MODIFICATA] !== undefined) {
      event.preventDefault()
    }
  }
}
